import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  acceptAllCookies,
  getDefaultCookiePreferences,
  readCookiePreferences,
  saveCookiePreferences,
} from '../../utils/cookiePreferences';

export default function CookieConsentBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = React.useState(false);
  const [settingsOpen, setSettingsOpen] = React.useState(false);
  const [analytics, setAnalytics] = React.useState(false);
  const [personalization, setPersonalization] = React.useState(false);
  const [marketing, setMarketing] = React.useState(false);

  React.useEffect(() => {
    const current = readCookiePreferences();
    if (!current) {
      setVisible(true);
      const defaults = getDefaultCookiePreferences();
      setAnalytics(defaults.analytics);
      setPersonalization(defaults.personalization);
      setMarketing(defaults.marketing);
      return;
    }
    setAnalytics(current.analytics);
    setPersonalization(current.personalization);
    setMarketing(current.marketing);
  }, []);

  const onAcceptAll = () => {
    acceptAllCookies();
    setVisible(false);
    setSettingsOpen(false);
  };

  const onReject = () => {
    saveCookiePreferences({ analytics: false, personalization: false, marketing: false });
    setVisible(false);
    setSettingsOpen(false);
  };

  const onSave = () => {
    saveCookiePreferences({ analytics, personalization, marketing });
    setVisible(false);
    setSettingsOpen(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] border-t border-slate-300 bg-white/95 p-4 shadow-2xl backdrop-blur">
      <div className="mx-auto max-w-6xl">
        <p className="text-sm font-semibold text-slate-900">{t('public.cookie_banner_title')}</p>
        <p className="mt-1 text-xs text-slate-600">{t('public.cookie_banner_body')}</p>

        {settingsOpen ? (
          <div className="mt-3 grid gap-2 sm:grid-cols-3">
            <label className="rounded-lg border border-slate-200 p-2 text-xs text-slate-700">
              <span className="block font-semibold">{t('public.cookie_banner_analytics')}</span>
              <input type="checkbox" checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} className="mt-1" />
            </label>
            <label className="rounded-lg border border-slate-200 p-2 text-xs text-slate-700">
              <span className="block font-semibold">{t('public.cookie_banner_personalization')}</span>
              <input
                type="checkbox"
                checked={personalization}
                onChange={(e) => setPersonalization(e.target.checked)}
                className="mt-1"
              />
            </label>
            <label className="rounded-lg border border-slate-200 p-2 text-xs text-slate-700">
              <span className="block font-semibold">{t('public.cookie_banner_marketing')}</span>
              <input type="checkbox" checked={marketing} onChange={(e) => setMarketing(e.target.checked)} className="mt-1" />
            </label>
          </div>
        ) : null}

        <div className="mt-3 flex flex-wrap gap-2">
          <button type="button" onClick={onAcceptAll} className="rounded-lg bg-slate-900 px-3 py-2 text-xs font-semibold text-white">
            {t('public.cookie_banner_accept')}
          </button>
          <button type="button" onClick={onReject} className="rounded-lg border border-slate-300 bg-white px-3 py-2 text-xs font-semibold text-slate-800">
            {t('public.cookie_banner_reject')}
          </button>
          <button
            type="button"
            onClick={() => (settingsOpen ? onSave() : setSettingsOpen(true))}
            className="rounded-lg border border-slate-300 bg-slate-50 px-3 py-2 text-xs font-semibold text-slate-800"
          >
            {settingsOpen ? t('public.cookie_banner_save_btn') : t('public.cookie_banner_settings_btn')}
          </button>
        </div>
      </div>
    </div>
  );
}
